module.exports = __webpack_public_path__ + "static/media/tap-back-svgrepo-com.0f375d01.svg";